// 一覧表示色
export class ReceptionDetailListColor {
  constructor(
    public expiredBackgroundColor: string,
    public nearlyExpiredBackgroundColor: string,
    public expiredForegroundColor: string,
    public nearlyExpiredForegroundColor: string,
    public backedForegroundColor: string,
    public temporaryForegroundColor: string,
  ) { }

  clone(): ReceptionDetailListColor {
    return new ReceptionDetailListColor(
      this.expiredBackgroundColor,
      this.nearlyExpiredBackgroundColor,
      this.expiredForegroundColor,
      this.nearlyExpiredForegroundColor,
      this.backedForegroundColor,
      this.temporaryForegroundColor
    );
  }
}
